import { hexStringToBuffer } from '@iotize/common/byte-converter';
import { TapRequestFrame } from '@iotize/tap/client/api';
import {
  TapRequestFrameBuilder,
  TapRequestHelper,
} from '@iotize/tap/client/impl';

import { Predicate } from './definitions';

const TAP_REQUEST_STRING_REGEX =
  /^(GET|PUT|POST)\s+(\/[0-9]+\/[0-9]*\/[0-9]+)\s?(\s+(0x[a-zA-Z0-9]+))?$/i;

export function createTapRequestFromString(request: string) {
  const match = TAP_REQUEST_STRING_REGEX.exec(request);
  if (match) {
    const methodType = match[1] as keyof typeof TapRequestFrame.MethodType;
    const path = match[2];
    const body = match[4] ? hexStringToBuffer(match[4]) : undefined;
    return TapRequestFrameBuilder.create(
      TapRequestFrame.MethodType[methodType],
      path,
      body,
    );
  } else {
    throw new Error(`Invalid tap request string format: "${request}".`);
  }
}

const tapRequestEqualFilter: (
  request: TapRequestFrame,
) => Predicate<TapRequestFrame> = (expectedRequest) => {
  return (request) => {
    return (
      TapRequestHelper.toString(expectedRequest) ===
      TapRequestHelper.toString(request)
    );
  };
};
